var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useEffect, useState } from "react";
import { ConfrontaQuestion } from "../ConfrontaQuestion/ConfrontaQuestion";
import { useCheckoutContext } from "../../../context/useCheckoutContext";
import { get } from "lodash";
import { useKushkiJsContext } from "../../../context/useKushkiJsContext";
import { configCardSections } from "../../../shared/constants/CheckoutContants";
export var ConfrontaQuestionSection = function () {
    var _a = useCheckoutContext(), secureOtp = _a.secureOtp, checkoutToken = _a.checkoutToken, _b = _a.handlers, setCheckoutSection = _b.setCheckoutSection, setConfrontaFail = _b.setConfrontaFail, setIsCheckout = _b.setIsCheckout, setCheckoutLoading = _b.setCheckoutLoading;
    var requestSecureServiceValidation = useKushkiJsContext().requestSecureServiceValidation;
    // @ts-ignore
    var questions = secureOtp.questions;
    var _c = useState(0), currentIndex = _c[0], setCurrentIndex = _c[1];
    var _d = useState([]), answers = _d[0], setAnswers = _d[1];
    var handleFinishQuestionnaire = function (answers) { return __awaiter(void 0, void 0, void 0, function () {
        var confrontaInfo, secureOtpRequest, response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCheckoutLoading(true);
                    confrontaInfo = {
                        answers: answers,
                        questionnaireCode: get(secureOtp, "questionnaireCode", ""),
                    };
                    secureOtpRequest = {
                        confrontaInfo: confrontaInfo,
                        secureService: get(checkoutToken, "secureService", ""),
                        secureServiceId: get(checkoutToken, "secureId", ""),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, requestSecureServiceValidation(secureOtpRequest)];
                case 2:
                    response = _a.sent();
                    if (response["code"] === "BIO000")
                        setIsCheckout(true);
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    console.info(e_1);
                    if (e_1.message === "ok") {
                        setConfrontaFail(false);
                        setIsCheckout(true);
                    }
                    else {
                        setConfrontaFail(true);
                        setIsCheckout(false);
                        setCheckoutSection(configCardSections.transferSubscription);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setCheckoutLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleSelectAnswer = function (newAnswer) {
        setAnswers(__spreadArrays(answers, [newAnswer]));
    };
    useEffect(function () {
        if (!answers.length)
            return;
        if (currentIndex + 1 < questions.length) {
            setCurrentIndex(currentIndex + 1);
        }
        else {
            handleFinishQuestionnaire(answers);
        }
    }, [answers]);
    return (React.createElement(ConfrontaQuestion, { question: questions[currentIndex], questionLength: questions.length, handleSelectAnswer: handleSelectAnswer }));
};
